module.exports = __webpack_public_path__ + "img/a3.76435764.jpg";